import React, { useState, useEffect, useRef } from "react";
import "./RequestPayout.css";
import { FiEdit } from "react-icons/fi";
import { FaUniversity } from "react-icons/fa";
import { IoCheckmarkCircle, IoCloseCircle } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router";
import api from "../../api/api";
import { useAuth } from "../../features/auth/AuthContext";
import { Payments } from "../../assets/images/images";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, TextField } from "@mui/material";
import FloatingAIButton from "../FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../state/reducers/chatDrawerReducers";
import Helper from "../../utils/Helper";

const STATUS_MAP = {
  3: { label: "Payout Failed", stepStatus: "failed" },
  2: {
    label: "Payout Completed"
    , stepStatus: "success"
  },
  4: { label: "Payout Processing", stepStatus: "success" },

};

const COMPLETED_STATUS = 2;
const FAILED_STATUS = 3;
const PROCESSING_STATUS = 4;
//const POLL_INTERVAL_MS = 60000; // poll every 1 minute
const POLL_INTERVAL_MS = 30000; // poll every 30 seconds






const buildStepsFromProgress = (progressData, withdrawAmount, currency_symbol , Location) => {

  const status = progressData?.data.status;

  const statusLabel =
    progressData?.data?.status_display ||
    STATUS_MAP[status]?.label ||
    "Processing";

  // const updatedAt = progressData?.data?.updated_at
  //   ? new Date(progressData?.data?.updated_at).toLocaleString("en-US", {
  //     day: "2-digit",
  //     month: "short",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     hour12: true,
  //   })
  //   : "-";
  const createdAt = Helper.formatDateTimeByLocation(
  progressData?.data?.created_at || progressData?.data?.created_at
,Location);

const updatedAt = Helper.formatDateTimeByLocation(
  progressData?.data?.updated_at || progressData?.data?.updated_at
,Location);



  const isFailed = status === FAILED_STATUS;
  const isCompleted = status === COMPLETED_STATUS;


  return [  
    {
      title: `Payout of ${currency_symbol || ''}${withdrawAmount} Initiated`,
      time:`${createdAt.date} ${createdAt.time}`,
      status: "success",
    },
    {
      title: isFailed ? "Payout Processing Failed" :isCompleted ? "Payout Processed" : statusLabel, //PR1-I1788
      time:`${updatedAt.date} ${updatedAt.time}`, status: isFailed ? "failed" : "success",
      ...(progressData?.data?.failure_message && {
        subtitle: progressData?.data?.failure_message,
      }),
    },
    {
title: isFailed ? "Payout Completion Failed" :"Payout Completion",  time:
    isCompleted || isFailed
      ? `${updatedAt.date} ${updatedAt.time}`
      : "-",
  status: isCompleted
    ? "success"
    : isFailed
    ? "failed"
    : "pending",
},
    // {
    //   title: "Payout Completion",
    //   time: new Date(progressData?.updated_at || Date.now()).toLocaleString(
    //     "en-US",
    //     {
    //       day: "2-digit",
    //       month: "short",
    //       hour: "2-digit",
    //       minute: "2-digit",
    //       hour12: true,
    //     }
    //   ), status: isCompleted
    //     ? "success"
    //     : isFailed
    //       ? "failed"
    //       : "pending"
    // },
  ];
};
const RequestPayout = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useAuth();
  const data = location?.state?.data;
  const NetBalance = data?.balance || 123456;
  const available_to_withdraw = data?.available_to_withdraw || "No Amount to Show";
  const [WithdrawAmount, setWithdrawAmount] = useState(() => localStorage.getItem("withdrawAmount") || "");
  const [showStepper, setShowStepper] = useState(false);
  const [steps, setSteps] = useState([]);
  const [showProcessPopup, setShowProcessPopup] = useState(false);
  const [withdrawResponse, setWithdrawResponse] = useState(null);
  const currency_symbol = useSelector((state) => state?.globalState?.currency_symbol || data?.currency_symbol)
  const isIndia = currency_symbol === "₹";
  const MIN_WITHDRAW_AMOUNT = isIndia ? 1 : 1; // ₹1 for India, $1 for others
  const [loading, setLoading] = useState(false)
  const [checkingStatus, setCheckingStatus] = useState(true);

  const geolocation = useSelector((state) => state?.globalState?.teacher_details?.data?.location);
  const getLocation = geolocation ? geolocation.split(",").pop().trim() : "";
  const Location = getLocation ? getLocation : "India";


  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const dispatch = useDispatch()
  const [activePayoutId, setActivePayoutId] = useState(
    () => localStorage.getItem("activePayoutId") || null
  );
  const [payoutInProgress, setPayoutInProgress] = useState(
    () => !!localStorage.getItem("activePayoutId")
  );
  const [payoutCompleted, setPayoutCompleted] = useState(false);
  const [payoutFailed, setPayoutFailed] = useState(false);

  const pollRef = useRef(null);

  const amountNumber = parseFloat(WithdrawAmount);
  const hasMinimumAmountError =
  WithdrawAmount !== "" &&
  !isNaN(amountNumber) &&
  amountNumber < MIN_WITHDRAW_AMOUNT;

  const hasInsufficientBalanceError =
  WithdrawAmount !== "" &&
  !isNaN(amountNumber) &&
  amountNumber > available_to_withdraw;
  // const isValidAmount =
  //   amountNumber > 0 &&
  //   amountNumber <= available_to_withdraw &&
  //   !payoutInProgress;

  // const isValidAmount =
  // amountNumber > 0 &&
  // !hasInsufficientBalanceError &&
  // !payoutInProgress;

  const isValidAmount =
  amountNumber >= MIN_WITHDRAW_AMOUNT &&
  !hasMinimumAmountError &&
  !hasInsufficientBalanceError &&
  !payoutInProgress;

  const persistPayoutId = (id, amount) => {
    localStorage.setItem("activePayoutId", id);
    localStorage.setItem("withdrawAmount", amount);
    setActivePayoutId(id);
    setPayoutInProgress(true);
    setPayoutCompleted(false);
  };

  const clearPayoutId = () => {
    localStorage.removeItem("activePayoutId");
    localStorage.removeItem("withdrawAmount");
    setActivePayoutId(null);
    setPayoutInProgress(false);
    // setPayoutCompleted(true);
  };

  // Stop polling helper
  const stopPolling = () => {
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  };

  const redirectRef = useRef(null);

  useEffect(() => {
    return () => {
      if (redirectRef.current) {
        clearTimeout(redirectRef.current);
      }
    };
  }, []);


  //payout flikker fix:https://chatgpt.com/c/6a57c780-e0ec-83ee-be69-6cf3a93eedec

  useEffect(() => {
    if (!token || !activePayoutId) return;
  if (!activePayoutId) {
    setCheckingStatus(false);
    return;
  }
    checkLatestStatus();
  }, [token, activePayoutId]);

  useEffect(() => {
  return () => {
//localStorage.removeItem("activePayoutId"); 
    localStorage.removeItem("withdrawAmount");
    // localStorage.removeItem("payoutInProgress");
    // if (!localStorage.getItem("activePayoutId")) {
    //   localStorage.removeItem("withdrawAmount");
    // }
  };
}, []);


  //useeffect for polling payout id only which is in progress and not completed or failed
  useEffect(() => {
  if (!token) return;

  const fetchLatestProcessingPayout = async () => {
    try {
      const res = await api.get("/payouts/latest-processing/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      const payoutId = res?.data?.data?.payout_id;
      const amount = res?.data?.data?.amount;

      if (!payoutId) return;


      // Restore state
      setActivePayoutId(payoutId);
      localStorage.setItem("activePayoutId", payoutId);
      localStorage.setItem("withdrawAmount", amount);    
      setPayoutInProgress(true);
      setShowStepper(true);
      setWithdrawAmount(amount);

      // Don't call startPolling here.
      // Your existing useEffect([token, activePayoutId]) will automatically
      // call checkLatestStatus() once activePayoutId is updated.
      //await checkLatestStatus(payoutId);    //payout flikker fix:https://chatgpt.com/c/6a57c780-e0ec-83ee-be69-6cf3a93eedec

    } catch (err) {
      console.error("Error fetching latest processing payout:", err);
    }
  };

  fetchLatestProcessingPayout();
}, [token]);

  const checkLatestStatus = async () => {
    try {
      const res = await api.get(`/payout/status/${activePayoutId}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });

      const status = res.data.data.status;

      if (status === COMPLETED_STATUS) {
        stopPolling();
        clearPayoutId();

        setPayoutCompleted(false);   // or true if you still want to show success briefly
        setPayoutFailed(false);
        setShowStepper(false);
        setSteps([]);
        setWithdrawAmount("");

        return;
      }

      if (status === FAILED_STATUS) {
     //   console.warn("Payout failed:", activePayoutId);
        stopPolling();
        clearPayoutId();
        setPayoutCompleted(false);
        setPayoutFailed(true);
        setShowStepper(false);
        setSteps([]);

        return;
      }

      startPolling(activePayoutId, WithdrawAmount);
    } catch (err) {
      console.error(err);
    }finally {
    setCheckingStatus(false);
  }
  };

  //  Poll getProgressData
  const getProgressData = async (payoutId, amount) => {
    if (!payoutId) return;
    try {
      const res = await api.get(`/payout/status/${payoutId}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });
      const progress = res?.data;
      //const status = progress?.data?.status

      // Rebuild steps from live data
      setSteps(buildStepsFromProgress(progress, amount || WithdrawAmount, currency_symbol , Location));
      setShowStepper(true);

      const isDone = progress?.data?.status === COMPLETED_STATUS;
      const isFailed = progress?.data?.status === FAILED_STATUS;
      const isProcess = progress?.data?.status === PROCESSING_STATUS;

      if (isDone) {
        stopPolling();
        clearPayoutId();
        setPayoutCompleted(true);
        setPayoutFailed(false);

        setWithdrawAmount("");
        redirectRef.current = setTimeout(() => {
          // navigate(-1); //PR1-I1785
          navigate("/revenue-details");

        }, 3000);
      } else if (isFailed) {
        stopPolling();
        clearPayoutId();
        setPayoutCompleted(false);
        setPayoutFailed(true);
        console.error("Payout failed:", progress?.failure_message);
      } else if (isProcess) {

        setPayoutInProgress(true);
        setPayoutCompleted(false);
        setPayoutFailed(false);
      }
    } catch (err) {
      console.error("getProgressData error:", err);
      // Optionally stop polling on persistent errors:
      // stopPolling(); clearPayoutId();
    }
  };

  //  Start polling once we have a payoutId 
  const startPolling = (payoutId, amount) => {
    stopPolling(); // clear any existing interval first
    getProgressData(payoutId, amount); // immediate first call
    pollRef.current = setInterval(
      () => getProgressData(payoutId, amount),
      POLL_INTERVAL_MS
    );
  };

  // Resume polling on mount if a payout was interrupted
  // useEffect(() => {
  //   if (activePayoutId && payoutInProgress) {
  //     setShowStepper(true);
  //     startPolling(activePayoutId, WithdrawAmount);
  //   }
  //   return () => stopPolling(); // cleanup on unmount

  // }, []); // run once on mount

  //addded this because of the issue of polling not working after page refresh in revenue component
  useEffect(() => {

    return () => stopPolling(); // cleanup on unmount

  }, []); // run once on mount

  //  Main withdraw handler
  const handleWithdrawPayment = async () => {
    try {
      setLoading(true)
      // Step 1 – initiate payout
      const firstResponse = await api.post(
        "/payouts/teacher/payout/",
        { amount: amountNumber },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      const payoutId = firstResponse?.data?.data?.payout_id;
      if (!payoutId) throw new Error("Payout ID not received from server");

      console.log("Payout ID:", amountNumber,WithdrawAmount);
      persistPayoutId(payoutId, amountNumber); // save immediately so a page refresh won't lose it
      // Optimistic steps while we wait for confirmation
      setSteps([
        {
          title: `Payout of ${currency_symbol ?? ""} ${amountNumber || WithdrawAmount } Initiated`,
          time: new Date().toLocaleString("en-US", {
            day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true,
          }),
          status: "success",
        },
        { title: "Payout Processing", time: "-", status: "pending" },

        { title: "Payout Completion", time: "-", status: "pending" },
      ]);
      setLoading(false)
      setShowStepper(true);

      // Step 2 – confirm/execute payout
      const secondResponse = await api.post(
        "/payouts/teacher/payout/",
        { payout_id: payoutId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      const responseData = secondResponse?.data;
      //console.log("Second API response:", responseData);
      setWithdrawResponse(responseData);

      // Start polling for live progress
      startPolling(payoutId, amountNumber);
    } catch (error) {
      console.error("Withdraw error:", error);
      // If initiation failed, don't lock the button
      if (!activePayoutId) {
        setPayoutInProgress(false);
      }
      setSteps((prev) =>
        prev.map((s, i) =>
          i === 1 ? { ...s, status: "failed", title: "Payout Failed" } : s
        )
      );
    } finally {
      setLoading(false);
    }
  };

  const handleWithdraw = () => {
    if (!isValidAmount) return;
    setShowProcessPopup(false);
    handleWithdrawPayment();
  };

  const handleEdit = () => {
    navigate("/dashboard/settings", { state: { activeTab: "accountDetails" } });
  };

  const handlesupportticket = () => {
    navigate("/SupportRequest")
  }

  const failedIndex = steps.findIndex((step) => step.status === "failed");

  return (
    <>
      <div className="withdraw-container">
        <div className="back-button" onClick={() => navigate(-1)}>
          <i className="fa-solid fa-chevron-left"></i>
          <span>Back</span>
        </div>
        <div className="need-help">
          <h4 onClick={handlesupportticket}>Need help?</h4>
        </div>
        <h2 className="page-title">Withdraw Amount</h2>

        {/* ── Progress Stepper ── */}
        {showStepper && (
          <div className="progress-wrapper">
            {steps.map((step, index) => {
              const isLast = index === steps.length - 1;
              let lineClass = "";

              // if (!isLast) {
              //   const nextStep = steps[index + 1];

              //   if (nextStep?.status === "success") {
              //     lineClass = "line-success";
              //   }

              //   if (nextStep?.status === "failed") {
              //     lineClass = "line-failed";
              //   }
              //   if (failedIndex !== -1 && index > failedIndex) lineClass = "";
              // }
if (!isLast) {
  const nextStep = steps[index + 1];

  if (index === 0) {
    // Always keep the first connector green
    lineClass = "line-success";
  } else {
    if (nextStep?.status === "success") {
      lineClass = "line-success";
    } else if (nextStep?.status === "failed") {
      lineClass = "line-failed";
    }
  }

  if (failedIndex !== -1 && index > failedIndex) {
    lineClass = "";
  }
}
              return (
                <div className="step-item" key={index}>
                  {!isLast && <div className={`step-line ${lineClass}`} />}

                  <div
                    className={`step-circle ${step.status === "success"
                      ? "circle-success"
                      : step.status === "failed"
                        ? "circle-failed"
                        : "circle-pending"
                      }`}
                  >
                    {step.status === "success" && <IoCheckmarkCircle />}
                    {step.status === "failed" && <IoCloseCircle />}
                  </div>

                  <div className="step-content">
                    <p>{step.title}</p>
                    <span>{step.time}</span>
                    {step.subtitle && (
                      <span className="step-subtitle">{step.subtitle}</span>
                    )}
                  </div>
                </div>             
              );
            })}
          </div>
        )}

        {/* ── Cards ── */}
        <div className="withdraw-grid">
          <div className="withdraw-card">
            <div className="withdraw-card-innerdiv">
              <p className="card-label">Available To Withdraw</p>
              <img src={Payments} alt="payment" />
            </div>
            <h3 className="amount">
              {currency_symbol ?? ""}
              {new Intl.NumberFormat("en-IN").format(isNaN(Number(available_to_withdraw)) ? 0 : Number(available_to_withdraw)
              )}
            </h3>

            <TextField
              fullWidth
              type="number"
              className="withdraw-input"

              value={WithdrawAmount}
              onChange={(e) => setWithdrawAmount(e.target.value)}
              placeholder={'Enter Withdrawal Amount'}
              disabled={payoutInProgress}
              variant="outlined"
              size="small"
  error={hasMinimumAmountError || hasInsufficientBalanceError}
  helperText={
    hasMinimumAmountError
      ? `Minimum withdrawal amount is ${currency_symbol}${MIN_WITHDRAW_AMOUNT}.`
      : hasInsufficientBalanceError
        ? "Entered amount higher than available to withdraw."
        : ""
  }
              InputProps={{
                startAdornment: (
                  <span style={{ marginRight: "4px", color: "#1A1A1A" }}>
                    {currency_symbol ?? ""}
                  </span>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                },
              }}
            />
            {/*     <input
              type="number"
              value={WithdrawAmount}
              onChange={(e) => setWithdrawAmount(e.target.value)}
              placeholder={`${currency_symbol ?? ""} | Enter Withdrawal Amount`}
              className="withdraw-input"
              disabled={payoutInProgress}
            /> */}
          </div>

          <div className="bank-card">
            <div className="bank-header">
              <p>Withdraw money to</p>
              <button className="edit-link" style={{
                border: "none", backgroundColor: "transparent", cursor: payoutInProgress ? "not-allowed" : "pointer", color: payoutInProgress ? "#888" : "#007BFF"
              }} disabled={payoutInProgress} onClick={handleEdit}>
                <FiEdit size={14} /> Edit
              </button>
            </div>

            <div className="bank-info">
              <FaUniversity className="bank-icon" />
              <div>
                <p className="bank-name">
                  {data?.bank_details?.bank_name || "XYZ bank"}.
                </p>
                <span className="bank-account">
                  XXXXXX{data?.bank_details?.acc_last4 ?? "****"}
                </span>
              </div>
            </div>
          </div>
        </div>
        {!checkingStatus &&payoutInProgress && (
          <div className="withdraw-processing-note">
            <div className="withdraw-processing-left">
              <i className="fa-regular fa-clock"></i>
              <span>
                A withdrawal of <strong>{currency_symbol}{WithdrawAmount}</strong> is in
                progress. You can start a new withdrawal once this one is completed.
              </span>
            </div>

            <button
              className="withdraw-processing-link"
              onClick={() => navigate(-1)}
            >
              Back to previous page
            </button>
          </div>
        )}

        {payoutFailed && (
          <div className="withdraw-failed-note">
            <div className="withdraw-processing-left">
              <i className="fa-regular fa-clock"></i>
              <span>
                Payout of <strong>{currency_symbol}{WithdrawAmount}</strong> failed to
                process. Please try again or contact support for assistance.
              </span>
            </div>

            <button
              className="withdraw-processing-link"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>
        )}

        {/* ── Withdraw Button ── */}
        <button
          onClick={() => setShowProcessPopup(true)}
          className={`withdraw-btn ${isValidAmount ? "active-withdraw" : ""}`}
          disabled={!isValidAmount}
        >
          {payoutInProgress ? "Withdraw" : "Withdraw"}
        </button>

        {/* {payoutInProgress && (
          <p className="note processing-note">
            ⏳ A payout is currently being processed. The button will re-enable
            once it completes.
          </p>
        )} */}

        {payoutCompleted && (
          <p className="note success-note">
            ✅ Your payout completed successfully!
          </p>
        )}

        {/* {payoutFailed && (
          <p className="note error-note">
            ❌ Your payout failed. Please try again or contact support.
          </p>
        )} */}

        <p className="note">
          Note: Withdrawals usually take 2–3 business days to reflect in your
          bank account.
        </p>
      </div>

      {/* ── Confirmation Popup ── */}
      {showProcessPopup && (
        <div className="overlay">
          <div className="popup">
            <h3>Confirm Withdrawal</h3>
            <p>
              Are you sure you want to withdraw{" "}
              <b>
                {currency_symbol ?? ""}
                {WithdrawAmount}
              </b>
              ?
            </p>
            <div className="popup-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowProcessPopup(false)}
              >
                Cancel
              </button>
              <button className="confirm-btn" onClick={handleWithdraw}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      {
        loading && (
          <>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
              <div className="w-[95%] max-w-[620px] rounded-md border-2 border-blue-500 bg-white px-8 py-8 shadow-lg">
                <div className="flex flex-col items-center justify-center gap-6">
                  {/* Loader */}
                  {/* <div className="h-14 w-14 animate-spin rounded-full border-[6px] border-gray-200 border-t-blue-500" /> */}
                  <CircularProgress size={60} />
                  {/* Text */}
                  <p className="w-full  border-blue-400 px-4 py-1 text-center text-sm font-medium text-black sm:text-base">
                    Please wait a moment while we initiate your withdrawal.
                  </p>
                </div>
              </div>
            </div>
          </>
        )
      }




      {/* <FloatingAIButton
              onClick={() => {
                dispatch(setDrawerState(!chatDrawerState.isOpen));
                dispatch(setIsWebAllowed(true));
                dispatch(setQueryMetaData(null));
              }}
            /> */}
    </>
  );
};

export default RequestPayout;